export const USER_LOGIN = {
  REQUEST: "USER_LOGIN_REQUEST",
  SUCCESS: "USER_LOGIN_SUCCESS",
  FAIL: "USER_LOGIN_FAIL",
};
export const UPDATE_USER = {
  REQUEST: "UPDATE_USER_REQUEST",
  SUCCESS: "UPDATE_USER_SUCCESS",
  FAIL: "UPDATE_USER_FAIL",
};

export const CHANGE_PASSWORD = {
  REQUEST: "CHANGE_PASSWORD_REQUEST",
  SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  FAIL: "CHANGE_PASSWORD_FAIL",
};

export const LOGOUT_USER = "LOGOUT_USER";
